import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
:root,
:host {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to right" or "to left" need to be switched to using deg values
 * 3) Background Position From is used for reversing animation from right to left at 0%
 * 4) Background Position To is used for reversing animation from right to left at 100%
 * 5) Rotate Icon to 180deg for nav button
 * 6) Transformation size for badge left positions
 * 7) Transformation size for badge right positions
 * 8 to 18) Padding values for Input Field Type Tel
 */
[dir=rtl] {
  --rtlTranslateX: 50%; /* 1 */
  --rtlGradientToRight: 270deg; /* 2 */
  --rtlBackgroundPositionFrom: -135%; /* 3 */
  --rtlBackgroundPositionTo: 0%; /* 4 */
  --rtlRotate180: 180deg; /* 5 */
  --rtlRotate135: 135deg;
  --rtlBadgeLeft: -1.5; /* 6 */
  --rtlBadgeRight: 1.5; /* 7 */
  --rtlTelTypeInputFieldPaddingStart: calc(var(--size-base-unit) * 5); /* 8 */
  --rtlTelTypeInputFieldPaddingEnd: calc(var(--size-base-unit) * 2); /* 9 */
  --rtlTelTypeInputFieldMedPaddingStart: calc(var(--size-base-unit) * 4.5); /* 10 */
  --rtlTelTypeInputFieldMedPaddingEnd: calc(var(--size-base-unit) * 1.5); /* 11 */
  --rtlTelTypeInputFieldSmPaddingStart: calc(var(--size-base-unit) * 4); /* 12 */
  --rtlTelTypeInputFieldSmPaddingEnd: calc(var(--size-base-unit) * 1); /* 13 */
  --rtlTelTypeInputFieldCharBeforePaddingEnd: calc(var(--size-base-unit) * 3.75); /* 14 */
  --rtlTelTypeInputFieldCharAfterPaddingStart: calc(var(--size-base-unit) * 6); /* 15 */
  --rtlTelTypeInputFieldCharAfterErrPaddingStart: calc(var(--size-base-unit) * 9); /* 16 */
  --rtlTelTypeInputFieldIconAfterErrPaddingStart: calc(var(--size-base-unit) * 8); /* 17 */
  --rtlTelTypeInputFieldIconCharAfterErrPaddingStart: calc(var(--size-base-unit) * 12); /* 18 */
  --rtlDisplayNone: none;
  --rtlDisplayBlock: block;
  --rtlDrawerRightTranslateX: -100%;
  --rtlDrawerLeftTranslateX: 100%;
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
 * style for text ellipsis
 */
/**
 * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
 */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */ /**
 * 1) Layout wrapper that houses layout section components to create a layouts like
 * sidebar layouts that are 1 row across and not a grid.
 * 2) Layout that is stacked on small screens and turns into a main column
 *    right sidebar on larger screens. Default is a 60%/40% layout
 * 2) The main column stretches the full width minus the sidebar width and gap.
 *    The sidebar column can either take in a sidebar width custom property. If that's
 *    not defined, fall back to 40%. calc is used to account for half of the gap in between items.
 */
.cat-c-layout {
  display: grid;
  gap: calc(var(--size-base-unit) * 2);
  grid-template-columns: minmax(0, 1fr);
}
@media all and (min-width: 60rem) {
  .cat-c-layout {
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - (var(--size-base-unit) * 1)); /* 2 */
  }
}

/**
 * Right sidebar layout break faster
 * 1) Right sidebar layout that breaks to a sidebar layout at a smaller viewport than default
 */
@media all and (min-width: 48rem) {
  .cat-c-layout--break-faster {
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - (var(--size-base-unit) * 1)); /* 2 */
  }
}

/**
 * Right sidebar layout break slower
 * 1) Right sidebar layout that breaks to a sidebar layout at a large viewport than default
 */
@media all and (min-width: 60rem) {
  .cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media all and (min-width: 75rem) {
  .cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - (var(--size-base-unit) * 1)); /* 2 */
  }
}

/**
 * Layout gap none
 * 1) Remove the gap between items on lg screens only when items sit beside one another
 */
.cat-c-layout--gap-none {
  gap: 0;
}
@media all and (min-width: 60rem) {
  .cat-c-layout--gap-none {
    grid-template-columns: minmax(0, 1fr) var(--cat-sidebar-width, 40%); /* 2 */
  }
}
@media all and (min-width: 48rem) {
  .cat-c-layout--gap-none.cat-c-layout--break-faster {
    gap: 0;
    grid-template-columns: minmax(0, 1fr) var(--cat-sidebar-width, 40%); /* 2 */
  }
}
@media all and (min-width: 60rem) {
  .cat-c-layout--gap-none.cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr);
    gap: calc(var(--size-base-unit) * 2);
  }
}
@media all and (min-width: 75rem) {
  .cat-c-layout--gap-none.cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr) var(--cat-sidebar-width, 40%); /* 2 */
  }
}

/**
 * Layout gap none
 * 1) Shrink the gap to 8px between items on lg screens only when items sit beside one another
 */
@media all and (min-width: 60rem) {
  .cat-c-layout--gap-sm {
    gap: calc(var(--size-base-unit) * 1);
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - (var(--size-base-unit) * 0.5));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-layout--gap-sm.cat-c-layout--break-faster {
    gap: 0;
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - (var(--size-base-unit) * 0.5)); /* 2 */
  }
}
@media all and (min-width: 60rem) {
  .cat-c-layout--gap-sm.cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr);
    gap: calc(var(--size-base-unit) * 2);
  }
}
@media all and (min-width: 75rem) {
  .cat-c-layout--gap-sm.cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - (var(--size-base-unit) * 0.5)); /* 2 */
  }
}

/**
 * Layout gap none
 * 1) Shrink the gap to 24px between items on lg screens only when items sit beside one another
 */
@media all and (min-width: 60rem) {
  .cat-c-layout--gap-lg {
    gap: calc(var(--size-base-unit) * 3);
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - (var(--size-base-unit) * 1.5));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-layout--gap-lg.cat-c-layout--break-faster {
    gap: 0;
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - (var(--size-base-unit) * 1.5)); /* 2 */
  }
}
@media all and (min-width: 60rem) {
  .cat-c-layout--gap-lg.cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr);
    gap: calc(var(--size-base-unit) * 2);
  }
}
@media all and (min-width: 75rem) {
  .cat-c-layout--gap-lg.cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - (var(--size-base-unit) * 1.5)); /* 2 */
  }
}

/**
 * Layout gap xl
 * 1) Widen the gap to 32px between items on lg screens only when items sit beside one another
 */
@media all and (min-width: 60rem) {
  .cat-c-layout--gap-xl {
    gap: calc(var(--size-base-unit) * 4);
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - (var(--size-base-unit) * 2));
  }
}
@media all and (min-width: 48rem) {
  .cat-c-layout--gap-xl.cat-c-layout--break-faster {
    gap: 0;
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - (var(--size-base-unit) * 2)); /* 2 */
  }
}
@media all and (min-width: 60rem) {
  .cat-c-layout--gap-xl.cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr);
    gap: calc(var(--size-base-unit) * 2);
  }
}
@media all and (min-width: 75rem) {
  .cat-c-layout--gap-xl.cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - (var(--size-base-unit) * 2)); /* 2 */
  }
}

/**
 * Left sidebar layout
 * 1) Layout that is stacked on small screens and turns into a left sidebar with main
 * content to the right
 * 2) The main column stretches the full width minus the sidebar width and gap.
 *    The sidebar column has a minimum width value (enough to accommodate navigation
 *    and other sidebar content) but stretches to fit the content placed inside it.
 */
@media all and (min-width: 60rem) {
  .cat-c-layout--left-sidebar {
    grid-template-columns: calc(var(--cat-sidebar-width, 40%) - (var(--size-base-unit) * 1)) minmax(0, 1fr); /* 2 */
  }
}

/**
 * Left sidebar layout break faster
 * 1) Left sidebar layout that breaks to a sidebar layout at a smaller viewport than default
 */
@media all and (min-width: 48rem) {
  .cat-c-layout--left-sidebar.cat-c-layout--break-faster {
    grid-template-columns: calc(var(--cat-sidebar-width, 40%) - (var(--size-base-unit) * 1)) minmax(0, 1fr); /* 2 */
  }
}

/**
 * Left sidebar layout break slower
 * 1) Left sidebar layout that breaks to a sidebar layout at a large viewport than default
 */
@media all and (min-width: 60rem) {
  .cat-c-layout--left-sidebar.cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media all and (min-width: 75rem) {
  .cat-c-layout--left-sidebar.cat-c-layout--break-slower {
    grid-template-columns: calc(var(--cat-sidebar-width, 40%) - (var(--size-base-unit) * 1)) minmax(0, 1fr); /* 2 */
  }
}
`;
       